import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psadetails-form',
  templateUrl: './psadetails-form.component.html',
  styleUrls: ['./psadetails-form.component.css']
})
export class PsadetailsFormComponent implements OnInit {
  title="PSA Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/psadetails-form/psadetails-form.component.ts